module.exports = __webpack_public_path__ + "img/elha-logo-black.eedd6aef.svg";